"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.some.js");
var _router = _interopRequireDefault(require("./router"));
var _store = _interopRequireDefault(require("./store"));
var _elementUi = require("element-ui");
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var _cookie = require("@/utils/cookie");
var _getPageTitle = _interopRequireDefault(require("@/utils/get-page-title"));
// progress bar
// progress bar style
// import { getToken } from '@/utils/auth' // get token from cookie

_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration

const whiteList = ['/login', '/auth-redirect']; // no redirect whitelist

// permission judge function
function hasPermission(roles, permissionRoles) {
  // if (roles.indexOf('admin') >= 0) return true // admin permission passed directly
  if (roles.indexOf('root') >= 0) return true; // admin permission passed directly
  if (!permissionRoles) return true;
  return roles.some(role => permissionRoles.indexOf(role) >= 0);
}
_router.default.beforeEach(async (to, from, next) => {
  // start progress bar
  _nprogress.default.start();

  // set page title
  document.title = (0, _getPageTitle.default)(to.meta.title);

  // determine whether the user has logged in
  // const hasToken = getToken()
  const hasToken = (0, _cookie.getCookie)('ACCESS_TOKEN');
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({
        path: '/'
      });
      _nprogress.default.done();
    } else {
      // determine whether the user has obtained his permission roles through getInfo

      const hasRoles = _store.default.getters.roles && _store.default.getters.roles.length > 0;
      if (hasRoles) {
        // console.log('store-roles', store.getters.roles)
        next();
      } else {
        try {
          // get user info
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          const data = await _store.default.dispatch('user/getInfo');
          // console.log('permission-getInfo', data)
          const {
            role
          } = await _store.default.dispatch('user/getInfo');

          // setCookie
          (0, _cookie.setCookie)('ROLES', role.join('|'));
          // generate accessible routes map based on roles
          const accessRoutes = await _store.default.dispatch('permission/generateRoutes', role);

          // dynamically add accessible routes
          _router.default.addRoutes(accessRoutes);

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({
            ...to,
            replace: true
          });
        } catch (error) {
          // remove token and go to login page to re-login
          await _store.default.dispatch('user/resetToken');
          _elementUi.Message.error(error || 'Has Error');
          // otr force redirect to login page
          // next(`/login?redirect=${to.path}`)
          next(`/login`);
          _nprogress.default.done();
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      // console.log('whiteList', to.path)
      next();
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      // next(`/login?redirect=${to.path}`)
      // console.log('Not whitelist', to.path)
      next(`/login`);
      _nprogress.default.done();
    }
  }
});
_router.default.afterEach(() => {
  // finish progress bar
  _nprogress.default.done();
});